<div
  class="my-snackbar"
  [class.warning-snackbar]="cssPrefix === 'warning'"
  [class.info-snackbar]="cssPrefix === 'info'"
  [class.success-snackbar]="cssPrefix === 'success'"
  [class.error-snackbar]="cssPrefix === 'error'"
>
  {{ data.message }}
  <div class="my-snackbar-action">
    <button class="snackbar-button" mat-button (click)="action()">{{ data.action }}</button>
  </div>
</div>
